import { OptionTitle } from "./OptionTitle"

export const AnythingElseOptions: Array<OptionTitle> = [
  { title: "My journey to this point", id: "CURRENT_JOURNEY_DETAILS" },
  { title: "Other journeys I'm on", id: "OTHER_JOURNEY_DETAILS" },
  { title: "Cultural considerations that influence my journey", id: "CULTURAL_CONSIDERATIONS" },
  { title: "Religious considerations that influence my journey", id: "RELIGIOUS_CONSIDERATIONS" },
  { title: "Something else", id: "SOMETHING_ELSE" }
]
